import React from "react";

import { Toggler } from "sulu-admin-bundle/components";
import { useTeamAuthorization } from "./TeamAuthorizationContext";

import { useTranslation } from "react-i18next";

const TeamToggler = () => {
    const { showArchived, setShowArchived } = useTeamAuthorization();

    const { t } = useTranslation();

    return (
        <Toggler checked={showArchived} onChange={setShowArchived}>
            {t("sulu_admin.club.team_authorization_archived")}
        </Toggler>
    );
};

export default TeamToggler;
